import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/energy-sources')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/energy-sources-page')),
  staticData: { titleKey: 'energySources' },
});
